import ListFilter from 'Shared/components/list-filter';
import isAfter from 'date-fns/isAfter';
import isWithinInterval from 'date-fns/isWithinInterval';
import parseISO from 'date-fns/parseISO';


const minDate = new Date(1, 0, 1);
const maxDate = new Date(9999, 0, 1);

const transactionDateFilter = (transaction, { fromDate, toDate }) => {
  if (isAfter((fromDate || minDate), (toDate || maxDate))) return false;

  return isWithinInterval(parseISO(transaction.date), {
    start: fromDate || minDate,
    end: toDate || maxDate,
  });
};

const TransactionFilter = (props) => (
  <ListFilter
    {...props}
    filterActions={[
      transactionDateFilter,
    ]}
  />
);

export default TransactionFilter;
